import type Address from 'types/address';

export default function getGoogleMapsLink(
  address: Address & { businessName?: string | undefined },
): string {
  const encodedAddress = encodeURIComponent(
    `${address.businessName ?? ''} ${address.line1}, ${address.line2}, ${
      address.city
    }, ${address.state} ${address.zipCode}`,
  );

  const queries: string[] = [`query=${encodedAddress}`];

  if (typeof address.placeId !== 'undefined') {
    queries.push(`query_place_id=${address.placeId}`);
  }

  return `https://www.google.com/maps/search/?api=1&${queries.join('&')}`;
}
